import {
  IonButton,
  IonCard,
  IonCol,
  IonItem,
  IonLabel,
  IonList,
  IonNote,
  IonRow,
  IonText,
} from "@ionic/react";
import { useDispatch, useSelector } from "react-redux";
import {
  setCheckAll,
  setShowMassiveSign,
  setShowModalToSignMassive,
} from "../../../store/documentsSignerList";
import { useHistory } from "react-router";
import { selectSignerDocuments } from "../../../store/documentsSignerList/selectors/selectSignerDocuments";

const colStyle = {
  maxWidth: "450px",
  padding: "20px",
};

export const WithDocuments = ({ count }: { count: number }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const listOfDocuments = useSelector(selectSignerDocuments);

  const handleCancel = () => {
    dispatch(setShowMassiveSign(false));
    history.replace("/app/acuerdos/firma/");
  };

  const handleGoToSignDocument = () => {
    dispatch(setShowMassiveSign(true));
    setTimeout(() => {
      dispatch(setCheckAll());
      dispatch(setShowModalToSignMassive(true));
    }, 500);
    history.replace("/app/acuerdos/firma/");
  };
  return (
    <>
      <IonRow class="ion-justify-content-center">
        <IonText class="ion-text-center">
          <h4>ACUERDOS PENDIENTES DE FIRMAR</h4>
        </IonText>
      </IonRow>
      <IonRow class="ion-justify-content-around">
        <IonCol class="ion-text-center" style={colStyle}>
          <IonText color="primary">
            Usted tiene {count} {count === 1 ? "documento pendiente" : "documentos pendientes"} de
            firmar: <br />
            <IonCard>
              <IonList>
                {listOfDocuments.map((document) => (
                  <IonItem key={document.id} lines="none">
                    <IonLabel class="ion-text-wrap">
                      <h2>• {document.title}</h2>
                      <p style={{ color: "gray" }}>{document.category?.name}</p>
                    </IonLabel>
                    <IonNote></IonNote>
                  </IonItem>
                ))}
              </IonList>
            </IonCard>
            <br />
            ¿Desea firmar todos los documentos?
          </IonText>
          <br />
          <br />
          <IonButton onClick={handleCancel} color="medium" fill="outline">
            No en este momento
          </IonButton>
          <IonButton onClick={handleGoToSignDocument}>Ir a firmar</IonButton>
        </IonCol>
      </IonRow>
    </>
  );
};
